module.exports = __webpack_public_path__ + "static/img/lg-chem-pr-portal.cff67a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lg-chem-pr-portal.jpg
// module id = A9IE
// module chunks = 0